import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._onGlobalClick = this._onGlobalClick.bind(this)
    document.addEventListener("click", this._onGlobalClick)
  }

  disconnect() {
    document.removeEventListener("click", this._onGlobalClick)
  }

  _onGlobalClick(event) {
    const trigger = event.target.closest('[data-bs-toggle="collapse"]') || event.target.closest('[data-collapse-toggle]')
    if (!trigger) return

    event.preventDefault()
    this.toggle(trigger)
  }

  toggle(trigger) {
    const selector = trigger.getAttribute("data-bs-target") || trigger.getAttribute("data-collapse-target") || trigger.getAttribute("href")
    if (!selector) return

    const target = document.querySelector(selector)
    if (!target) return

    const isShowing = target.classList.contains("show")

    const parentSelector = trigger.getAttribute("data-bs-parent") || target.getAttribute("data-bs-parent")
    if (parentSelector && !isShowing) {
      const parent = document.querySelector(parentSelector)
      if (parent) {
        parent.querySelectorAll(".collapse.show").forEach((sibling) => {
          if (sibling !== target) {
            this._hide(sibling)
          }
        })
      }
    }

    if (isShowing) {
      this._hide(target, trigger)
    } else {
      this._show(target, trigger)
    }
  }

  _show(target, trigger = null) {
    if (target.classList.contains("show")) return

    this._dispatch(target, "show.bs.collapse")
    this._dispatch(target, "collapse:show")

    target.classList.add("show")

    const triggers = this._findTriggers(target)
    triggers.forEach((t) => {
      t.setAttribute("aria-expanded", "true")
      t.classList.remove("collapsed")
    })

    this._dispatch(target, "shown.bs.collapse")
    this._dispatch(target, "collapse:shown")
  }

  _hide(target, trigger = null) {
    if (!target.classList.contains("show")) return

    this._dispatch(target, "hide.bs.collapse")
    this._dispatch(target, "collapse:hide")

    target.classList.remove("show")

    const triggers = this._findTriggers(target)
    triggers.forEach((t) => {
      t.setAttribute("aria-expanded", "false")
      t.classList.add("collapsed")
    })

    this._dispatch(target, "hidden.bs.collapse")
    this._dispatch(target, "collapse:hidden")
  }

  _findTriggers(target) {
    if (!target.id) return []
    const id = `#${target.id}`
    return Array.from(
      document.querySelectorAll(
        `[data-bs-toggle="collapse"][data-bs-target="${id}"], [data-bs-toggle="collapse"][href="${id}"], [data-collapse-toggle][data-collapse-target="${id}"]`
      )
    )
  }

  _dispatch(element, type) {
    const event = new CustomEvent(type, { bubbles: true, cancelable: true })
    element.dispatchEvent(event)
    return event
  }
}
